import { render, staticRenderFns } from "./_ibcLogin.vue?vue&type=template&id=4fec86f8&scoped=true&lang=pug&"
import script from "./_ibcLogin.vue?vue&type=script&lang=js&"
export * from "./_ibcLogin.vue?vue&type=script&lang=js&"
import style0 from "./_ibcLogin.vue?vue&type=style&index=0&id=4fec86f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec86f8",
  null
  
)

export default component.exports